module.exports = __webpack_public_path__ + "img/564845034.a1f10324.jpg";